// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"common__msignaturepad___1fytd","m-signature-pad--body":"common__m-signature-pad--body___WAKn3","m-signature-pad--footer":"common__m-signature-pad--footer___2H9n5","description":"common__description___3YXJW","button":"common__button___3l4Hu","clear":"common__clear___Hh88O","save":"common__save___1WWf9","m-signature-pad":"common__m-signature-pad___3r-O9","github":"common__github___1YJwL","react-entry":"common__react-entry___1WPTr","floatRight":"common__floatRight___1z8yj","floatLeft":"common__floatLeft___2EVlU"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/common.scss
// module id = Z5Js
// module chunks = client